import styled from 'styled-components';

export const InputTextStyle = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ widthPercentage }) => {
    return widthPercentage;
  }};
  label {
    margin-bottom: 5px;
    font-size: ${({ theme }) => {
      return theme.fonts.size.small;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
  input {
    border: ${({ theme }) => {
      return theme.border;
    }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    padding: 3px;
  }
`;
